export const TEAMVIEWER_DOWNLOAD_URL = 'https://www.teamviewer.com/fr/download/windows/';